// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2ofys","content":"content--3GPvB","title":"title--1zOYx","select_language":"select_language--1tAFs"};